import {Controller} from "stimulus"

export default class extends Controller {

    toggleFilter() {
        const includeInactive = document.getElementById('include_inactive').checked;
        window.location.href = "/cms/spotlight_items?include_inactive=" + includeInactive;
    }
}
